export const SUGGESTED_PATHS = [
    '/job_positions',
    '/admin/candidates',
    '/admin/contractors',
    '/admin/customers',
    '/admin/checkins',
] as const;
